
import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from "@/app/hooks/useTheme";

export default function ChattingMobile({ isMobile }: { isMobile: boolean }) {
    const phoneNumber = '+971501286691';
    const { mode } = useTheme(); // Subscribe to theme changes to force re-render

    return (<>
        <Box style={{
            position: "fixed",
            bottom: "1rem",
            right: isMobile ? "0rem" : "1rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            zIndex: 1000,
            padding: "0.5rem",
            borderRadius: "8px", 
            backgroundColor: "var(--section-bg)",
            transition: "background-color 0.3s ease"
        }}>
            <div>
                <a href={`https://wa.me/${phoneNumber}`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/whatspMb.svg`} loading='lazy' width={isMobile ? "100%" : "40%"} height={isMobile ? "60%" : "40%"} alt="whatsapp" />
                </a>
            </div>
        </Box>
    </>)
}